// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"206":"2e5b54c9","215":"cf14bf4d","334":"4559568c","391":"69b51223"}[chunkId] || chunkId) + "." + {"206":"985cd925b2d0af40","215":"ef2fc37dba8af720","291":"aa34b3d681564d1c","334":"fe591e26463507fb","391":"7883868009ac5c26","489":"59ccf97774cc9b60"}[chunkId] + ".js";
};